import Vue from "vue";

//成功弹窗
const success = (message = "成功", duration = "3000") => {
  return Vue.prototype.$message.success({
    message,
    duration,
  });
};

//警告弹窗
const warning = (message = "警告", duration = "3000") => {
  return Vue.prototype.$message.warning({
    message,
    duration,
  });
};

//错误弹窗
const error = (message = "警告", duration = "3000") => {
  return Vue.prototype.$message.error({
    message,
    duration,
  });
};

function minuteToTime(minute) {
  var hour = Math.floor(minute / 60);
  var min = minute % 60;
  hour = hour < 10 ? "0" + hour : hour;
  min = min < 10 ? "0" + min : min;
  return hour + ":" + min;
}

//日期格式化
const formDate = (date = new Date(), type = 1) => {
  date = new Date(date);
  let year = date.getFullYear();
  let month =
    date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  let houre = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
  let minutes =
    date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
  let seconds =
    date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
  switch (type) {
    case 1:
      return `${year}-${month}-${day}`;
    case 2:
      return `${year}-${month}-${day} ${houre}:${minutes}:${seconds}`;
    case 3:
      return `${year}年${month}月${day}日`;
  }
};

export default {
  success,
  warning,
  error,
  formDate,
  minuteToTime,
};



// WEBPACK FOOTER //
// ./src/common/js/utils.js